import { DateTime } from "luxon"

import { getFlowChartData } from "@/features/dashboards/api/LWRN/getFlowChartData"
import { getGasChartData } from "@/features/dashboards/api/LWRN/getGasChartData"
import Dashboard from "@/features/dashboards/components/Dashboard"
import type { KPIGroupRequest } from "@/types/kpiTypes"

export default function LWRN() {
  const gasMetricsConfig: KPIGroupRequest = {
    aggType: "Monthly",
    asOf: DateTime.now().startOf("day").toJSDate(),
    returnSize: 6,
    kpis: [
      {
        $type: "calc",
        name: "Raw Inlet Gas per Minute",
        unit: "SCFM",
        expression: "[60] / 1.44",
        aggFunction: "Average",
        location: 5,
        typeId: 1,
      },
      {
        $type: "basic",
        id: 60,
        typeId: 1,
        location: 5,
      },
      {
        $type: "basic",
        id: 65,
        typeId: 1,
        location: 5,
      },
      {
        $type: "basic",
        id: 61,
        typeId: 1,
        location: 5,
      },
      {
        $type: "calc",
        name: "Uptime",
        unit: "%",
        aggFunction: "Average",
        location: 5,
        typeId: 1,
        expression: "[110]/24*100",
      },
      {
        $type: "calc",
        name: "Efficiency",
        unit: "%",
        aggFunction: "Average",
        location: 5,
        typeId: 1,
        preAggregate: true,
        expression: "[80] / ([61] * ([110] / 24)) * 100",
      },
      { $type: "basic", id: 80, location: 5, typeId: 1 },
      { $type: "basic", id: 70, location: 5, typeId: 1 },
      { $type: "basic", id: 55, location: 5, typeId: 1 },
    ],
  }

  return (
    <Dashboard
      config={{
        kpiTable: {
          request: gasMetricsConfig,
          paddingArray: [16, 16, 32, 16, 32, 32, 16, 16, 16],
        },
        rollingChart: {
          totalDays: 180,
          averageDays: 7,
          primaryKPIs: [
            { $type: "basic", id: 61, location: 5, typeId: 1 },
            {
              $type: "basic",
              id: 80,
              location: 5,
              typeId: 1,
            },
          ],
        },
        gasChart: {
          fetcher: getGasChartData,
          location: 5,
        },
        flowChart: {
          fetcher: getFlowChartData,
          location: 5,
        },
        chartGroup: {
          returnSize: 10,
          aggType: "Weekly",
          asOf: DateTime.now()
            .setZone("America/Chicago")
            .startOf("week")
            .minus({ days: 1 })
            .toJSDate(),
          kpis: [
            {
              $type: "calc",
              expression: "[60]/1.44",
              name: "Raw Inlet Gas per Minute",
              unit: "SCFM",
              location: 5,
              aggFunction: "Average",
            },
            {
              $type: "calc",
              name: "Efficiency",
              unit: "%",
              aggFunction: "Average",
              location: 5,
              preAggregate: true,
              expression: "[70] / ([61] * ([110] / 24)) * 100",
            },
            {
              $type: "calc",
              name: "Uptime",
              unit: "%",
              aggFunction: "Average",
              location: 5,
              expression: "[110]/24*100",
            },
            {
              $type: "basic",
              id: 70,
              location: 5,
            },
          ],
        },
      }}
    />
  )
}
